import axios from "axios";
import { Notification } from "element-ui";
import defaultStringify from "./stringify";
import errCodes from "./code";
import i18n from "@/i18n";
import { getBusinessId, getTenantId } from "@/lib/auth";

let client;
let currentPrefix; // init 默认使用上一次的 prefix
let currentHeaders;
export const getPreFix = () => {
    return currentPrefix;
};
export function init({ baseURL: prefix = currentPrefix, headers, timeout = 15000 }) {
    const baseURL = (() => {
        if (prefix) return prefix; // 允许各类其他奇葩玩法
        /*
            测试环境（本机与测试环境保持一致）：
                动态api域名：test-api-interopen.gbot.qq.com
                静态域名：test-interopen.gbot.qq.com
            预发布环境：
                动态api域名：pre-api-interopen.gbot.qq.com
                静态域名：pre-interopen.gbot.qq.com
            正式环境：
                动态api域名：open.vlinkapi.com
                静态域名：vlink.tencent.com
            */
        let before;
        switch (document.domain) {
            case "vlink.tencent.com":
            case "interopen.gbot.qq.com":
                return "//open.vlinkapi.com";
            case "pre-interopen.gbot.qq.com":
                before = "pre-";
                break;
            case "test-interopen.gbot.qq.com":
            default:
                // 保险起见，我们默认对接测试环境
                before = "test-";
                break;
        }
        return `//${before}api-interopen.gbot.qq.com`;
    })();
    currentPrefix = baseURL;
    currentHeaders = {
        "Content-Type": "application/x-www-form-urlencoded",
        ...headers
    };
    client = axios.create({
        baseURL: `${baseURL}`,
        responseType: "json",
        withCredentials: true,
        timeout,
        headers: currentHeaders
    });
}
function setAjaxPrefix(prefix = process.env.VUE_APP_MOCK) {
    init({ baseURL: prefix });
}
setAjaxPrefix();
window.setAjaxPrefix = setAjaxPrefix;

function handleResp(response = { status: 500, statusText: "Network Error" }) {
    const errInfo = {};
    const errObj = { response, errInfo };
    if (200 !== response.status) {
        errInfo.title = i18n.t("all.ajax_error_title");
        errInfo.message = `[${response.status}] ${response.statusText}`;
    } else {
        const { err_code: code, result } = response.data || {};
        switch (code) {
            case 0:
                return result;
            default: {
                const errDesc = errCodes[code];
                errObj.code = code;
                if (!errDesc) {
                    errInfo.message = response.data.err_msg || errCodes[10001]();
                } else if ("function" === typeof errDesc) {
                    errInfo.message = errDesc();
                } else {
                    const { title, message, action } = errDesc;
                    errInfo.title = title;
                    errInfo.message = message();
                    if (false === (action && action())) {
                        errInfo.disabled = true;
                    }
                }
            }
        }
    }
    errInfo.disabled || Notification.error(errInfo);
    throw errObj;
}

function isString(input) {
    return "string" === typeof input;
}

function isFormData(form) {
    return form instanceof FormData;
}

// 多业务，所有请求加business_id, tenant_id参数
function addBusinessIdParam(param = {}) {
    if (!isString(param)) {
        param.business_id = getBusinessId();
        param.tenant_id = getTenantId();
    }

    if (isFormData(param)) {
        param.append("business_id", getBusinessId());
        param.append("tenant_id", getTenantId());
    }

    return param;
}

export async function get(path, param, { stringify = defaultStringify } = {}) {
    const paramWithBusiness = addBusinessIdParam(param);
    const query = stringify(paramWithBusiness);
    if (!isString(query)) {
        throw new Error("GET 类型不能传递文件之类的数据噢");
    }
    let response;
    try {
        response = await client.get(`${path}${undefined === query ? "" : `?${query}`}`);
    } catch (err) {
        response = err.response;
    }
    const result = handleResp(response);
    return result;
}

export async function post(url, param, { stringify = defaultStringify } = {}) {
    let response;
    const paramWithBusiness = addBusinessIdParam(param);
    const data = stringify(paramWithBusiness);
    try {
        response = await client({
            method: "post",
            url,
            data,
            headers: {
                ...currentHeaders,
                "Content-Type": isString(data) ? "application/x-www-form-urlencoded" : "multipart/form-data"
            }
        });
    } catch (err) {
        response = err.response;
    }
    const result = handleResp(response);
    return result;
}

export default { get, post, defaultStringify };
